import React, { useState, useEffect } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getTranslate } from "react-localize-redux";

import {
  Row,
  Col,
  Modal,
  ModalBody,
  Spinner,
  Button,
  Alert,
  ListGroup,
  ListGroupItem,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import FileSaver from "file-saver";
import axios from "axios";
import { configActions } from "../../../../redux/actions";
import { getReportData, handleErrors } from "../../../../utils";

import { EditConfigReport } from "../configuredReports/editConfigReport";

class ReportNotFoundError extends Error {
  constructor(message) {
    super(message);
    this.name = "ReportNotFoundError";
    this.message = message;
  }
}

var qs = require("qs");
const ReportsDownloadForm = ({
  config,
  translate,
  location,
  history,
  dispatch,
  isExternalUser,
}) => {
  const [report, setReport] = useState(null);
  const [configReport, setConfigReport] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);

  const [editReportIsActive, setEditReportIsActive] = useState(false);
  const [editReportIsInternalUse, setEditReportIsInternalUse] = useState(false);
  const [msg, setMsg] = useState({});

  const [pastNextLaunchConfirmModal, setPastNextLaunchConfirmModal] =
    useState(false);
  const [reportDataToBeSaved, setReportDataToBeSaved] = useState(null);

  const [reportIdNotFound, setReportIdNotFound] = useState(null);

  useEffect(() => {
    let _searchQry = location.search;
    if (_searchQry) {
      let queryObj = qs.parse(_searchQry.substr(1));
      if (queryObj.search) {
        const fetchData = async () => {
          try {
            const response = await axios.get("Reporting/reports", {
              params: {
                SearchText: queryObj.search,
                PageNumber: 1,
              },
              paramsSerializer: function (params) {
                return qs.stringify(params, { arrayFormat: "repeat" });
              },
            });
            if (response.data.Errors && response.data.Errors.length > 0) {
              throw new Error(response.data.Errors[0]);
            }
            if (response.data.Data && response.data.Data.length > 0) {
              setReport(response.data.Data[0]);
              setReportIdNotFound(null);
            } else {
              setReport(null);
              throw new ReportNotFoundError("No report found");
            }
          } catch (error) {
            if (error.name === "ReportNotFoundError") {
              setReportIdNotFound(queryObj.search);
            } else {
              handleErrors(error, dispatch, "Fetcing report");
            }
          }
        };
        fetchData();
      }
    }
  }, [location.search, dispatch]);

  const handleDownloadableFile = (fullPath, pipelineId, fileName) => {
    var params = {
      PipelineId: pipelineId,
      FileLocation: fullPath,
    };
    setLoadingFile(true);
    axios
      .get("Reporting/Pipelines/DownloadFileDirectly", {
        params: params,
        responseType: "blob",
      })
      .then((response) => {
        var data = new Blob([response.data]);
        FileSaver.saveAs(data, fileName);
        setLoadingFile(false);
      })
      .catch((error) => {
        //TODO: handle error
        setLoadingFile(false);
      });
  };

  const getFileNameFromPath = (fullPath, pipelineId) => {
    var fileName = (fullPath || "").replace(/^.*[\\\/]/, "");
    return (
      <button
        className="default-button-link"
        onClick={(e) => {
          handleDownloadableFile(fullPath, pipelineId, fileName);
        }}
      >
        {fileName}
      </button>
    );
  };

  const getAdditionalInfo = (type, additionalInfo, pipelineId) => {
    if (type === "exec") {
      return (
        <ul style={{ listStyleType: "disc", margin: "0.5em 1em" }}>
          {additionalInfo.generatedFiles &&
            additionalInfo.generatedFiles.length &&
            additionalInfo.generatedFiles.map((path, key) => {
              return <li key={key}>{getFileNameFromPath(path, pipelineId)}</li>;
            })}
        </ul>
      );
    }
  };

  const showMoreDetails = () => {
    var qData = {
      search: report.pipelineInstanceId,
    };
    history.push("/exec-reports?" + qs.stringify(qData));
  };

  const openOtherReports = () => {
    let qData = {
      config_report_id: report.reportDefinitionId,
    };
    history.push("/exec-reports?" + qs.stringify(qData));
  };

  const editReportConfiguration = async () => {
    const response = await axios.get("Reporting/Definitions/GetById", {
      params: { definitionId: report.reportDefinitionId },
    });
    const _configReport = response.data.Data;
    delete _configReport.isActive;
    setConfigReport(_configReport);
    setEditReportIsActive(_configReport.active);
    setEditReportIsInternalUse(_configReport.internalUse);

    var _repDescJson = config.reportsDescriptions || [];
    var repDescObjRef =
      _repDescJson.find((obj) => {
        return (
          obj.reporttemplatename === _configReport.reportPipelineDefinitionId
        );
      }) || {};
    dispatch(
      configActions.toggleEditConfigReportModal(
        true,
        _configReport,
        repDescObjRef
      )
    );
  };

  const handleActiveChange = () => {
    setEditReportIsActive(!editReportIsActive);
  };

  const handleInternalUseChange = () => {
    setEditReportIsInternalUse(!editReportIsInternalUse);
  };

  const handleFormSave = (
    data,
    selectedReportType,
    reportForEdit,
    resetLoader
  ) => {
    let reportData = getReportData(data, selectedReportType, {
      ...reportForEdit,
      active: editReportIsActive,
      internalUse: editReportIsInternalUse,
    });
    if (
      reportData.validationErrorMsgs &&
      reportData.validationErrorMsgs.length
    ) {
      if (resetLoader) resetLoader();
      setMsg({
        header: "Validation Error",
        message: (
          <ListGroup>
            {reportData.validationErrorMsgs.map((item, index) => (
              <ListGroupItem
                key={index}
                color="danger"
                dangerouslySetInnerHTML={{
                  __html: item,
                }}
              />
            ))}
          </ListGroup>
        ),
      });
    } else if (reportData.schedulesConfirmRequired) {
      setPastNextLaunchConfirmModal(true);
      setReportDataToBeSaved(reportData.data);
    } else {
      saveReport(reportData.data, resetLoader);
    }
  };

  const saveReport = (params, resetLoader) => {
    let commitUpdateDefinition = false;
    let commitUpdateSchedule = false;

    const originalDefinitionParams = Object.assign({}, configReport);
    delete originalDefinitionParams["schedules"];

    const definitionParams = Object.assign({}, params);
    delete definitionParams["schedules"];

    commitUpdateDefinition =
      JSON.stringify(originalDefinitionParams) !==
      JSON.stringify(definitionParams);

    // call update schudules if triggerType === "recurringreport"
    let schedulesParams;
    if (
      params.triggerType === "recurringreport" &&
      params.schedules &&
      params.schedules[0]
    ) {
      const originalSchedulesParams = Object.assign(
        {},
        configReport.schedules[0],
        {
          state: configReport.active ? "Pending" : "Canceled",
        }
      );

      schedulesParams = Object.assign({}, params.schedules[0], {
        //reportdefinitionid: response.data.Data["_id"],
        state: params.active ? "Pending" : "Canceled",
      });

      commitUpdateSchedule =
        JSON.stringify(originalSchedulesParams) !==
        JSON.stringify(schedulesParams);
    }

    if (commitUpdateDefinition) {
      updateDefinition(
        definitionParams,
        commitUpdateSchedule,
        schedulesParams,
        resetLoader
      );
    } else if (commitUpdateSchedule) {
      updateSchedule(schedulesParams, resetLoader);
    } else {
      if (resetLoader) resetLoader();
      setMsg({
        header: "Report Update",
        message: <Alert color="danger">Nothing to update</Alert>,
      });
    }

    if (commitUpdateDefinition || commitUpdateSchedule) {
      setConfigReport(JSON.parse(JSON.stringify(params)));
    }
  };

  const updateDefinition = (
    definitionParams,
    commitUpdateSchedule,
    schedulesParams,
    resetLoader
  ) => {
    axios
      .put("Reporting/Definitions/Update", definitionParams)
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          setMsg({
            header: "Server Error",
            message: (
              <Alert color="danger">
                <p>Server failed with the following errors:</p>
                {response.data.Errors.join("<br />")}
              </Alert>
            ),
          });
        } else {
          if (
            response.data.ValidationErrors &&
            response.data.ValidationErrors.length
          ) {
            if (resetLoader) resetLoader();
            setMsg({
              header: "Validation Error",
              message: (
                <Alert color="danger">
                  <p>The following fields are missed:</p>
                  {response.data.ValidationErrors.join("<br />")}
                </Alert>
              ),
            });
          } else if (commitUpdateSchedule) {
            updateSchedule(schedulesParams, resetLoader);
          } else {
            // reload and close window
            if (resetLoader) resetLoader();
            setMsg({
              header: "Report Update",
              message: (
                <Alert color="success">Report updated successfully</Alert>
              ),
            });
          }
        }
      });
  };

  const updateSchedule = (schedulesParams, resetLoader) => {
    axios
      .put("Reporting/Schedules/Update", { Data: schedulesParams })
      .then((response) => {
        if (response.data.Errors && response.data.Errors.length) {
          if (resetLoader) resetLoader();
          setMsg({
            header: "Server Error",
            message: (
              <Alert color="danger">
                <p>Server failed with the following errors:</p>
                {response.data.Errors.join("<br />")}
              </Alert>
            ),
          });
        } else {
          // reload and close window
          if (resetLoader) resetLoader();
          setMsg({
            header: "Report Update",
            message: <Alert color="success">Report updated successfully</Alert>,
          });
        }
      });
  };

  const toggleMsgBox = () => {
    setMsg({});
    setPastNextLaunchConfirmModal(false);
    setReportDataToBeSaved(null);
  };

  const togglePastNextLaunchConfirmModal = () => {
    setPastNextLaunchConfirmModal(!pastNextLaunchConfirmModal);
  };

  const handleYesConfirmNextLaunchDialog = () => {
    saveReport(reportDataToBeSaved, null);
    setPastNextLaunchConfirmModal(false);
    setReportDataToBeSaved(null);
  };
  const handleNoConfirmNextLaunchDialog = () => {
    setPastNextLaunchConfirmModal(false);
    setReportDataToBeSaved(null);
  };

  /* if (!report) {
		return null;
	} */
  const components = report && report.components;
  let additionalInfoContent = null;
  (components || []).forEach((item, index) => {
    if (item.type !== "transport") {
      additionalInfoContent = getAdditionalInfo(
        item.type,
        item.additionalInfo,
        report.pipelineInstanceId
      );
    }
  });

  return (
    <div className="settings-main row">
      <div className="report-download-container">
        <div className="row">
          <div className="col-sm-12 platform-container">
            {report && (
              <>
                <Row>
                  <Col>
                    You can download files of report by clicking links below:
                  </Col>
                </Row>
                <Row>
                  <Col>{additionalInfoContent}</Col>
                </Row>
                <Row style={{ marginTop: "0.5em" }}>
                  <Col>
                    <table style={{ borderCollapse: "collapse" }}>
                      <tr>
                        <td>
                          <div style={{ marginBottom: "0.5em" }}>
                            <Button
                              style={{ width: "100%" }}
                              color="primary"
                              className="btn-posti-default"
                              onClick={showMoreDetails}
                            >
                              {translate("ShowMoreDetails")}
                            </Button>
                          </div>
                        </td>
                        <td />
                      </tr>
                      <tr>
                        <td>
                          <div style={{ marginBottom: "0.5em" }}>
                            <Button
                              style={{ width: "100%" }}
                              color="primary"
                              className="btn-posti-default"
                              onClick={openOtherReports}
                            >
                              {translate(
                                "OpenOtherReportsConfiguration"
                              )}
                            </Button>
                          </div>
                        </td>
                        <td />
                      </tr>
                      {!isExternalUser && (
                        <tr>
                          <td>
                            <div style={{ marginBottom: "0.5em" }}>
                              <Button
                                style={{ width: "100%" }}
                                color="primary"
                                className="btn-posti-default"
                                onClick={editReportConfiguration}
                              >
                                {translate("EditReportConfiguration")}
                              </Button>
                            </div>
                          </td>
                          <td />
                        </tr>
                      )}
                    </table>
                  </Col>
                </Row>
              </>
            )}
            {reportIdNotFound && (
              <Row>
                <Col>
                  <Alert color="warning" style={{ marginBottom: 0 }}>
                    The report with the id {`[${reportIdNotFound}]`} was not
                    found. If this is an error, please contact the Posti
                    Messaging Customer Service.
                    <br />
                    <br />
                    NOTE! It is only possible to download reports which are less
                    than one month old.
                  </Alert>
                </Col>
              </Row>
            )}
          </div>
        </div>
      </div>
      <Modal isOpen={loadingFile}>
        <ModalBody>
          <Spinner color="warning" /> Downloading...
        </ModalBody>
      </Modal>
      <EditConfigReport
        reportDefinitionId={configReport && configReport._id}
        reportPipelineDefinitionId={
          configReport && configReport.reportPipelineDefinitionId
        }
        handleFormSave={handleFormSave}
        handleActiveChange={handleActiveChange}
        isActive={editReportIsActive}
        handleInternalUseChange={handleInternalUseChange}
        internalUse={editReportIsInternalUse}
      />

      <Modal isOpen={!!msg.message} toggle={toggleMsgBox}>
        <ModalHeader toggle={toggleMsgBox}>{msg.header}</ModalHeader>
        <ModalBody>{msg.message}</ModalBody>
        <ModalFooter className="text-center">
          <Button
            color="primary"
            className="switchBtn"
            style={{ width: "100px" }}
            onClick={toggleMsgBox}
          >
            OK
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={pastNextLaunchConfirmModal}
        toggle={togglePastNextLaunchConfirmModal}
      >
        <ModalHeader toggle={togglePastNextLaunchConfirmModal}>
          {translate("ScheduleNextLaunchWarning")}
        </ModalHeader>
        <ModalBody>
          <Alert color="warning">
            You choose a date in a past for scheduled reports. That will launch
            a generation and delivery of all the reports from the day you
            specified till current day.
            <br />
            This could lead to spamming recipients of e-mails and uploading a
            lot of files to SFTP/FTP connections.
            <br />
            Do you really want to set the date in the past?
          </Alert>
        </ModalBody>
        <ModalFooter className="text-center">
          <Button
            color="secondary"
            style={{ width: "90px" }}
            onClick={handleYesConfirmNextLaunchDialog}
          >
            Yes
          </Button>
          <Button
            color="primary"
            className="EventSearchSubmit"
            style={{ marginLeft: "60px", width: "90px" }}
            onClick={handleNoConfirmNextLaunchDialog}
          >
            No
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

function mapStateToProps(state) {
  const { config, files, documents, fileSearch, docSearch, locale } = state;
  return {
    config,
    files,
    documents,
    fileSearch,
    docSearch,
    translate: getTranslate(locale),
  };
}

const connectedDownloadForm = connect(mapStateToProps)(
  withRouter(ReportsDownloadForm)
);
export default connectedDownloadForm;
